'use strict';

require('../../style/index.css');

require('../../grid/style/index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/col/style/css.js
// module id = 425
// module chunks = 0